import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { CARNET_PHOTOS } from "@/lib/assets";
import { ArrowRight } from "lucide-react";

const CAPTIONS = {
  fr: ["Capitaine des sables", "Sirène des criques", "L'enquête « Dans la niche »", "Trésors de nature"],
  en: ["Captain of the sands", "Mermaid of the coves", "The 'Dans la niche' investigation", "Nature's treasures"],
};

export default function Carnet() {
  const { t, lang } = useLang();
  const captions = CAPTIONS[lang];
  return (
    <div data-testid="carnet-page" className="bg-[#fbf6ec] min-h-screen">
      <div className="pt-32 pb-12 max-w-6xl mx-auto px-5 lg:px-10">
        <span className="font-script text-[#e07a5f] text-3xl">{t.carnet.kicker}</span>
        <h1 className="font-head font-extrabold text-[#6f7d54] text-4xl md:text-6xl tracking-tight mt-1 mb-4">
          {t.carnet.title}
        </h1>
        <p className="font-body text-[#3a4d68] text-lg max-w-2xl leading-relaxed">{t.carnet.text}</p>
      </div>

      <div className="max-w-6xl mx-auto px-5 lg:px-10 pb-16 grid md:grid-cols-2 gap-8">
        {CARNET_PHOTOS.map((p, i) => (
          <figure
            key={i}
            data-testid={`carnet-full-${i}`}
            className={`bg-white p-4 pb-10 shadow-xl ${i % 2 ? "rotate-1" : "-rotate-1"} hover:rotate-0 transition-transform duration-300`}
          >
            <img src={p.src} alt={captions[i]} className="w-full aspect-[4/3] object-cover" />
            <figcaption className="font-script text-2xl text-[#6f7d54] mt-3 text-center">{captions[i]}</figcaption>
          </figure>
        ))}
      </div>

      <div className="text-center pb-24">
        <Link
          to="/reservation"
          data-testid="carnet-page-cta"
          className="inline-flex items-center gap-2 rounded-full bg-[#e07a5f] hover:bg-[#cf6a50] text-white font-bold text-lg px-8 py-4 transition-all hover:-translate-y-0.5"
        >
          {t.carnet.cta} <ArrowRight size={20} />
        </Link>
      </div>
    </div>
  );
}
